import { Callout } from "@octopusdeploy/design-system-components";
import React from "react";
interface ErrorContentProps {
    errorMessage?: string;
}
export function ErrorContent({ errorMessage }: ErrorContentProps) {
    return (<div>
            <Callout type="danger" title="Unable to configure ephemeral environments">
                {errorMessage}
            </Callout>
        </div>);
}
